<template>
  <v-container grid-list-md>
    <v-layout row>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-flex xs12 md10>
              <h3>{{missing.title}}</h3>
            </v-flex>
            <v-flex xs12 md2 v-if="missing.award > 0">
              <span>مكافأة بقيمة {{missing.award}} ر.س</span>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-layout>
              <v-flex>المدينة: {{missing.city}}</v-flex>
              <v-flex>التصنيف: {{missing.category}}</v-flex>
            </v-layout>
            <v-responsive class="description">{{missing.description}}</v-responsive>
            <v-carousel v-if="missing.images != null && missing.images.length > 0">
              <v-carousel-item v-for="(item,i) in missing.images" :key="i" :src="item"></v-carousel-item>
            </v-carousel>
            <v-flex
              xs12
              v-if="missing.coordinates != null && missing.coordinates.length > 0 && missing.coordinates[0].x != 0"
            >
              <h4>الموقع</h4>

              <maps-component
                :passedMarkers="{position:{lng:missing.coordinates[0].x,lat: missing.coordinates[0].y}|| {}}"
                v-bind:clickable="false"
              ></maps-component>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <comments v-if="missing.id" :missing-id="missing.id"></comments>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Comments from "../components/comments/Comments";
import MapsComponent from "../components/Common/MapsComponent";

export default {
  components: {
    Comments,
    MapsComponent
  },
  computed: {
    ...mapState({
      missing: state => state.MissingStore.missing
    })
  },
  methods: {
    ...mapActions(["getMissing"])
  },

  mounted() {
    this.getMissing(this.$route.params.id);
  }
};
</script>


<style scoped>
.description {
  min-height: 200px;
}
</style>

